import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { deleteDocument } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useDeleteDocument = (): UseMutationResult<void, AxiosError, number> => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (id) => {
            await deleteDocument({ path: { id } });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.documents() });
        },
    });
};
